const slugify = (input) => (
  String(input)
    .normalize('NFD') // split diacritics
    .replace(/[\u0300-\u036f]/g, '') // remove diacritics
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-') // non-alphanumerics to hyphen
    .replace(/^-+|-+$/g, '') // trim hyphens
);

export const getBookieLogoUrl = (bookie_name) => (
    `https://bonusbank.com.au/bookies/${slugify(bookie_name)}.png`
);

